{
	"title": "Αναφορά λογισμικού ανοιχτού κώδικα",
	"backTitle": "Πίσω"
}
